import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCurrencyPesos: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconCurrencyPesos"><Path d="M20 11H4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><Path d="M20 7H4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><Path d="M7 21V3H12C15.3137 3 18 5.68629 18 9C18 12.3137 15.3137 15 12 15H7.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconCurrencyPesos;
